'use strict';

module.exports = require('react/lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/flint/flintjs-deps/~/react-dom/server.js
 ** module id = 308
 ** module chunks = 1
 **/